<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/Settings/UserInfo/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'settings/userInfo'
    }
  },

  async created () {
    this.$store.commit(`settings/setAttr`, {
      name: 'menuSelected',
      value: 'user-info'
    })
    await this.$store.dispatch(`${this.modelName}/get`)
    this.$store.dispatch(`${this.modelName}/set`)
  }
}
</script>
